/**
 * HUB-I — Liens navigation Hub Activité (référence équipe = équipe-magasins).
 */
import { activiteVentesLinkFromFilters } from '../historique/ventesDisplay';

export const EQUIPE_MAGASINS_PATH = '/admin/equipe-magasins';
export const LEGACY_UTILISATEURS_PATH = '/utilisateurs';
export const ACTIVITE_PATH = '/activite';

export function activiteTabUrl(tab, params = {}) {
  const searchParams = new URLSearchParams({ tab, ...params });
  return `${ACTIVITE_PATH}?${searchParams.toString()}`;
}

/** Recherche vente depuis GlobalSearch → onglet Ventes du Centre Activité. */
export function activiteVenteSearchUrl(search, extra = {}) {
  return activiteVentesLinkFromFilters({
    search: search || undefined,
    period: extra.period || '30d',
    ...extra,
  });
}

/** Référence métier équipe / rôles / affectations M1·M2 (super admin). */
export function equipeMagasinsUrl(tab = 'users') {
  return `${EQUIPE_MAGASINS_PATH}?tab=${tab}`;
}
